import { render, staticRenderFns } from "./PerformanceList.vue?vue&type=template&id=220d873a&scoped=true"
import script from "./PerformanceList.vue?vue&type=script&lang=js"
export * from "./PerformanceList.vue?vue&type=script&lang=js"
import style0 from "./PerformanceList.vue?vue&type=style&index=0&id=220d873a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220d873a",
  null
  
)

export default component.exports